module.exports = __webpack_public_path__ + "static/psychology-of-money-2b8eb993fd0e10a2b3b5bb6863d95102.webp";